import { useState, type ReactNode } from 'react';

interface CollapsedSectionProps {
  icon: string;
  label: string;
  count: number;
  children: ReactNode;
  defaultOpen?: boolean;
}

export default function CollapsedSection({
  icon,
  label,
  count,
  children,
  defaultOpen = false,
}: CollapsedSectionProps) {
  const [open, setOpen] = useState(defaultOpen);

  return (
    <div className="border-t border-gray-100">
      <button
        onClick={() => setOpen(!open)}
        className="flex w-full items-center gap-2 px-4 py-3 text-sm text-gray-600 hover:bg-gray-50 active:bg-gray-100 transition-colors"
        style={{ minHeight: '48px' }}
      >
        <span className="text-base">{icon}</span>
        <span className="font-medium">{label}</span>
        <span className="rounded-full bg-gray-100 px-2 py-0.5 text-xs font-semibold text-gray-500">
          {count}
        </span>
        <svg
          className={`ml-auto h-4 w-4 text-gray-400 transition-transform duration-200 ${
            open ? 'rotate-180' : ''
          }`}
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          strokeWidth={2}
        >
          <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" />
        </svg>
      </button>
      <div
        className={`overflow-hidden transition-all duration-200 ${
          open ? 'max-h-[2000px] opacity-100' : 'max-h-0 opacity-0'
        }`}
      >
        <div className="px-4 pb-4">{children}</div>
      </div>
    </div>
  );
}
